import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OkAloneService } from 'src/app/ok-alone.service';
import { FormControl, FormGroup } from '@angular/forms';

import Utils from 'src/app/utils';

@Component({
  selector: 'app-workers',
  templateUrl: './workers.component.html',
  styleUrls: ['./workers.component.scss']
})

export class WorkersComponent implements OnInit {

  workers : any;

  view : any;
  sort = 'name';
  monitor = 'all';
  group = 'all';
  search = '';

  groups:any = [];

  u = Utils;

  pagination = { page: 1, pageSize: 1, itemCount: 1, totalPages: 1, pageArray: [1], totalCount: 1 };

  constructor(private router: Router, private route: ActivatedRoute, public okService: OkAloneService) { }

  ngOnInit(): void {

    this.pagination.page = 1;
    this.getWorkers();

  }

  getWorkers(){

    let filter = {
      sort: this.sort,
      monitor: this.monitor,
      group: this.group,
      search: this.search,
      page: this.pagination.page,
      // companies: this.formGroup.value.companies.join()
    }

    //console.log('filter', filter);

    this.okService.get("workers",filter)
    .subscribe((data) => {

      this.workers = data.body;
      this.pagination = this.okService.setPagination(data.headers) ?? this.pagination;
      this.groups = [{id:'all',name:'All Workers'},{id:'none',name:'No Group'}].concat(this.okService.groups);


    });


  }

  changePage(){
    //console.log('page',this.okService.pagination.page);
    this.getWorkers();
  }

  updateFilter(){
      this.getWorkers();

  }


  // Get the worker token and login as that worker

  dashboardLogin(worker:any){

    let url = this.okService.dashboardUrl+"/worker/update/"+worker.id+"?ul="+this.okService.session.token+"&cid="+worker.company_id;

    window.open(url);

  }

  clearFilter(){
    this.monitor = 'all';
    this.group = 'all';
    this.search = '';
    this.updateFilter();
  }


  export(){
    this.okService.download("workers/export");
  }

}
